// extracted by mini-css-extract-plugin
export default {"getStartedPage":"styles_getStartedPage__yi3qw"};